import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useSelector, shallowEqual } from "react-redux";
import {
  getPatientMedications,
  addPatientMedicationsIntoDB,
} from "../../_redux/patientService";
import { useRxData, useRxCollection } from "rxdb-hooks";

export const Medications = () => {
  const { patientId } = useParams();
  const collection = useRxCollection("medications");

  const { user } = useSelector(
    ({ auth }) => ({
      user: auth.user,
    }),
    shallowEqual
  );

  const queryConstructor = (collection) =>
    collection.findOne().where("pid").equals(patientId);

  const { result } = useRxData("medications", queryConstructor);

  useEffect(() => {
    if (!result.length && collection) {
      getPatientMedications(patientId, user.practice.id).then((response) => {
        addPatientMedicationsIntoDB(patientId, response, collection);
      });
    }
  }, [patientId, collection]);

  return (
    result && (
      <div className="sm:px-6 w-full">
        <div className="bg-white py-4 md:py-7 px-4 md:px-8 xl:px-10"></div>
        <div className="mt-7 overflow-x-auto">
          <table className="w-full whitespace-nowrap">
            <tbody>
              <tr className="focus:outline-none h-16 border border-gray-100 rounded">
                <td className="">
                  <div className="flex items-center pl-5">
                    <p className="text-base font-medium leading-none text-black mr-2">
                      Medications
                    </p>
                  </div>
                </td>
                <td className="pr-24">
                  <div className="flex justify-end">
                    <p className="text-base font-medium leading-none text-black ml-2">
                      Onset Date
                    </p>
                  </div>
                </td>
              </tr>
              {result && result.length
                ? result[0]?.medications.map((medication) => {
                    return (
                      <tr
                        key={medication.id}
                        className="focus:outline-none h-16 border border-gray-100 rounded"
                      >
                        <td className="">
                          <div className="flex items-center pl-5">
                            <p className="text-base font-medium leading-none text-gray-700 mr-2">
                              {medication.name}
                            </p>
                          </div>
                        </td>
                        <td className="pr-24">
                          <div className="flex justify-end">
                            <p className="text-sm leading-none text-gray-600 ml-2">
                              {moment(medication.updated).format("MM/DD/YYYY")}
                            </p>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </table>
        </div>
      </div>
    )
  );
};
